module.exports = __webpack_public_path__ + "static/media/dubai.6893f77e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dubai.jpg
// module id = 36
// module chunks = 0